<style>

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/signup-bg-wizard.jpg");
  background-size: cover;
  color: black;
  overflow-y: scroll;
}

.margin{
  margin-top: 50px;
}

.image{
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 500px;
}

.out{
  border: 1px gray solid;
  margin-bottom: 10px;
  display: none;
}

.button-container{
  position: fixed;
  z-index: 51;
  left: 0;
  right: 0;
  bottom: 0;
}
.buttons{
  margin: 10px;
}

.center{
  text-align: center;
  color: white;
}
.icon-supervised_user_circle{
  font-size: 150px;
}
.icon-camera_alt{
  font-size: 50px;
}
</style>

<div class="bg">
  
  {#if photo}
  
  <div class="image">
    <Cropper image="{photo}" bind:crop bind:zoom aspect="{1}" on:cropcomplete="{doCrop}"></Cropper>
  </div>
  
  <!-- hidden element -->
  <div class="out">
    <img id="image" src="{out}" alt="">
  </div>
  
  <!-- hidden element -->
  <div class="out">
    <canvas id="canvas" width="1000px" height="1000px"></canvas>
  </div>
  
  <div class="button-container">
  
    <div class="buttons">
      <button on:click="{addPhoto}">Upload New Photo</button>
    </div>
    <div class="buttons">
      <button on:click="{clearPhoto}">Clear Photo</button>
    </div>
    
    <div class="buttons">
      <button on:click="{ () => pop() }">Done</button>
    </div>
    
  </div>
  
  {:else}
  
  <div class="title-signup" on:click="{addPhoto}">Add a photo</div>
  
  <div class="center" on:click="{addPhoto}">
    <i class="icon-supervised_user_circle"></i>
  </div>
  
  <div class="center" on:click="{addPhoto}">
    <i class="icon-camera_alt"></i>
  </div>
  
  <div class="buttons">
    <button on:click="{addPhoto}">+ Add Photo</button>
  </div>
  
  <div class="buttons">
    <button on:click="{ () => pop() }">Cancel</button>
  </div>
  
  {/if}

</div>

<input style="display:none" type="file" accept=".jpg, .jpeg, .png" on:change="{ (e) => onFileSelected(e) }" bind:this="{fileInput}" >


<script>

import {push, pop, replace, location} from 'svelte-spa-router';
export let params = {};

import Cropper from "svelte-easy-crop";

import Signup from "../../../../helpers/Signup.js";
import Validate from "../../../../helpers/Validate.js";
import Generate from "../../../../helpers/Generate.js";
import Photos from "../../../../helpers/Photos.js";

import { onMount } from "svelte";
onMount(async () => {
  try {
    Signup.verifyPersonalObject();
  } catch (e) {
    console.log("error:", e);
    return;
  }
  
  
  
  // Signup.saveToPersonalObject("photos", [ "", "", "", "", "", "", ]);
  photos = Signup.getPersonalObject("photos");

  // console.log("photos:", photos);
  // console.log("params.index:", params.index);
  
  if (photos.length == 0) {
    photos = [ 
      {c: "nop", i: "", p: ""},
      {c: "nop", i: "", p: ""},
      {c: "nop", i: "", p: ""},
      {c: "nop", i: "", p: ""},
      {c: "nop", i: "", p: ""},
      {c: "nop", i: "", p: ""},
    ];
  }
  
  if (photos[params.index] != "") {
    photo = photos[params.index].p;
    image.src = photo;
  }
  
  
  // Signup.saveToPersonalObject("photoIds", [ "", "", "", "", "", "", ]);
  photoIds = Signup.getPersonalObject("photoIds");
  
  if (photoIds.length == 0) {
    photoIds = [ "", "", "", "", "", "", ];
  }

});


let photos = [ 
  {c: "nop", i: "", p: "", t: "", m: ""},
  {c: "nop", i: "", p: "", t: "", m: ""},
  {c: "nop", i: "", p: "", t: "", m: ""},
  {c: "nop", i: "", p: "", t: "", m: ""},
  {c: "nop", i: "", p: "", t: "", m: ""},
  {c: "nop", i: "", p: "", t: "", m: ""},
];
let photoIds = [ "", "", "", "", "", "", ];
let photo = "";
let crop = { x: 0, y: 0 };
let zoom = 1;
let out = "";
let image = new Image();
let canvas = null;
let ctx = null;
let fileInput = "";


function addPhoto() {
  fileInput.click();
}


function onFileSelected(e) {
  if (e.target.files.length > 0) {
    let timage = e.target.files[0];
    let treader = new FileReader();
    treader.readAsDataURL(timage);
    treader.onload = async (e) => {
      photo = e.target.result;
      image.src = photo;
      await Signup.saveToPersonalObject("photosSaved", false);
    };
  }
}


async function doCrop(e) {
  canvas = document.getElementById('canvas');
  ctx = canvas.getContext('2d');
  
  // console.log("e.detail:", e.detail);
  let x = e.detail.pixels.x;
  let y = e.detail.pixels.y;
  let w = e.detail.pixels.width;
  let h = e.detail.pixels.height;
  
  ctx.drawImage(image,
        x, y,   // Start at x,y pixels from the left and the top of the image (crop),
        w, h,   // "Get" a w,h area from the source image (crop),
        0, 0,     // Place the result at 0, 0 in the canvas,
        1000, 1000); // With as w,h: 100, 100 (scale)  
        
  out = canvas.toDataURL();
  
  photos[params.index].c = "new";
  photos[params.index].i = Generate.id();
  photos[params.index].p = await Photos.resize(out, 800, 800, 0.7);
  photos[params.index].m = await Photos.resize(out, 200, 200, 0.8);
  photos[params.index].t = await Photos.resize(out, 100, 100, 0.8);
  
  await Signup.saveToPersonalObject("photos", photos);
  
  photoIds[params.index] = photos[params.index].i;
  
  await Signup.saveToPersonalObject("photoIds", photoIds);
  await Signup.saveToPersonalObject("photosSaved", false);
  
}


async function clearPhoto() {
  photo = "";
  photos[params.index].c = "nop";
  photos[params.index].i = "";
  photos[params.index].p = "";
  await Signup.saveToPersonalObject("photos", photos);
  photoIds[params.index] = "";
  await Signup.saveToPersonalObject("photoIds", photoIds);
  await Signup.saveToPersonalObject("photosSaved", false);
  
}


</script>